import { Box, Divider } from "@chakra-ui/react";
import colors from "app/colors";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import React, { memo } from "react";
import NewMessageUploadAttachmentList from "../_shared/new-message-upload-attachment-list";

interface IProps {
  draftId: string;
}

const ComposeAttachmentList = ({ draftId }: IProps) => {
  const { draft, hasAttachments, files, isDraftLoaded } = useMessageThreadDraft(
    { draftId },
  );

  const gifs = draft?.gifList ?? [];

  if (!isDraftLoaded || !hasAttachments) return null;

  return (
    <Box w="full">
      <Divider borderColor={colors.grayPrimary} />
      <NewMessageUploadAttachmentList
        draftId={draftId}
        files={files}
        gifs={gifs}
      />
    </Box>
  );
};

export default memo(ComposeAttachmentList);
